import React from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import { ENV } from '@config/envConfig';

const AuthZero = ({ children }: { children: JSX.Element}) => {
  const domain = ENV.VITE_AUTH0_DOMAIN || import.meta.env.VITE_AUTH0_DOMAIN;
  const clientId = ENV.VITE_AUTH0_CLIENT_ID || import.meta.env.VITE_AUTH0_CLIENT_ID;
  const externalAuthEnabled = String(ENV.VITE_AUTH0_ENABLED ?? import.meta.env.VITE_AUTH0_ENABLED) === 'true';

  return (
    externalAuthEnabled ? (
      <Auth0Provider
        domain={domain}
        clientId={clientId}
        authorizationParams={{
          redirect_uri: window.location.origin,
          audience: 'https://newsoftys.ksec.cl/',
          scope: 'openid profile email',
        }}
      >
        {children}
      </Auth0Provider>
    )
      : children
  );
};

export default AuthZero;
